<!-- Navigation -->
<nav class="navbar navbar-custom " role="navigation">
  <div class="dropdown">
    <span> <a (click)= "profileIconClick()"><img class="profile_image" src = "./assets/img/user.png"></a></span>
    <div class="dropdown-content">
<!--               <a class="page-scroll" (click)= "register1Click()" style="cursor: pointer;" i18n>Register</a> -->
      <a class="page-scroll" (click)= "profileClick()" style="cursor: pointer;" i18n>Profile</a>
<a *ngIf="is_country_fp" class="page-scroll" (click)= "manageTeamClick()" style="cursor: pointer;" i18n>Manage Team</a>
      <a class="page-scroll" (click)= "feedbackClick()" style="cursor: pointer;" i18n>Feedback</a>
      <a class="page-scroll" (click)= "logoutClick()" style="cursor: pointer;" i18n>Logout</a>
    </div>
  </div>
<lang-change></lang-change>
<div class="container-fluid">
<div class="navbar-header">
    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-main-collapse">
        Menu <i class="fa fa-bars"></i>
    </button>
</div>
<!-- Collect the nav links, forms, and other content for toggling -->
<div class="collapse navbar-collapse navbar-main-collapse">
    <ul class="nav navbar-nav">
        <!-- Hidden li included to remove active class from introduction link when scrolled up past introduction section -->
        <li class="hidden">
            <a href="#page-top"></a>
        </li>
        <li>
            <a class="page-scroll intro-home" (click) = "homeButtonClick()" i18n="@@intro header Home">Home</a>
        </li>
        <li>
            <a class="page-scroll intro-home" (click) = "introBtnClick()" i18n>Introduction</a>
        </li>
        <li>
            <a class="page-scroll intro-home" (click) = "compBtnClick()" i18n>Components</a>
        </li>
        <li>
            <a class="page-scroll intro-home" (click) = "viewSummaryBtnClick()" i18n>Summary View</a>
        </li>
    </ul>
</div>
<!-- /.navbar-collapse -->
</div>
<!-- /.container -->
</nav>


// WEBPACK FOOTER //
// ./src/app/online-course-header/online-course-header.component.html